// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDatamodelmgrOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDatamodelmgrOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDatamodelmgrOutlined = function DrrpDatamodelmgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDatamodelmgrOutlinedSvg
  }));
};

DrrpDatamodelmgrOutlined.displayName = 'DrrpDatamodelmgrOutlined';
export default React.forwardRef(DrrpDatamodelmgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDatamodelmgrOutlined.js
// module id = 2543
// module chunks = 0